/* MODULE IMPORTS */
import React, { Component } from "react";
import ContextConstructor from "../Context/Context";
import sendLogError from "../../sendLogError";

/* CSS IMPORT */
import "./NotificationBanner.css";
import alertaCircleImg from "../../images/alertaCircle.png";
import mailUnopenedImg from "../../images/mailUnopened.png";

class NotificationBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationsList: [],
      hasUnpaidQuota: false,
      hasNotification: false,
      page: this.props.page,
    };
  }

  componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populateNotifications();
    }
  }
  
  componentWillUnmount() {
    if (this.abortController) {
        this.abortController.abort();
    }
  }

  render() {
    const quotaSection = (
      <div
        className="notification-banner-section"
        style={this.state.page == "profile" ? { width: "100%" } : {}}>
        <img src={alertaCircleImg} width="26px" />
        <span>Encontra-se com a quota associativa por liquidar.</span>
      </div>
    );
    const items = this.state.notificationsList.map((notification, i) => {
      return (
        <div
          className="notification-banner-section"
          key={i}
          style={this.state.page == "profile" ? { width: "100%" } : {}}
          onClick={() => {
            this.clickedNotification(notification.id);
          }}>
          <img src={mailUnopenedImg} width="26px" />
          <span>{notification.topic}</span>
        </div>
      );
    });
    if (this.state.notificationsList.length !== 0) {
      return (
        <div className="notification-banner-container">
          {/*DESCOMENTAR PARA VOLTAR A TER TOP NOTIFICATION DE QUOTAS this.state.hasUnpaidQuota ? quotaSection : <div/>*/}
          {items}
        </div>
      );
    } else
      return (
        <div className="no-top-notification">
          {/*DESCOMENTAR PARA VOLTAR A TER TOP NOTIFICATION DE QUOTAS  this.state.hasUnpaidQuota ? quotaSection : <div/>*/}
        </div>
      );
  }

  async clickedNotification(id) {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`,
        };

        const response = await fetch(
            `/Notifications/DismissTopNotification?Id=${id}`,
            {
                method: "POST",
                headers
            }
        );

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }
        
        this.populateNotifications();
    } catch (error) {
        console.error("Error dismissing notification:", error);

        sendLogError(error.message, "clickedNotification");
    }
  }

  async getQuotasState() {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`
        };

        const response = await fetch("/Quotas/GetFees", { headers });

        if (!response.ok) {
            throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();

        // garante número (segurança)
        const totalValue = Number(data?.totalValue || 0);

        const hasUnpaidQuota = totalValue !== 0;

        this.setState({
            hasUnpaidQuota
        });

    } catch (err) {
        console.error("Error fetching quotas:", err);

        this.setState({
            hasUnpaidQuota: false
        });

        sendLogError(err.message, "getQuotasState");
    }
  }
  
  async populateNotifications() {
    try {
        // cancelar anterior
        if (this.abortController) {
            this.abortController.abort();
        }

        this.abortController = new AbortController();

        const { selectedUserID, idToken } = this.context;

        const response = await fetch(
            `/Notifications/GetTopNotifications?ClientId=${selectedUserID}`,
            {
                headers: {
                    Authorization: `Bearer ${idToken}`
                },
                signal: this.abortController.signal
            }
        );

        if (!response.ok) {
          this.setState({
            notificationsList: [],
            hasNotification: false
          });
          return;
        }

        const data = await response.json();

        const sorted = Array.isArray(data)
            ? [...data].sort((a, b) => a.priority - b.priority)
            : [];

        const hasUnread = sorted.some(item => !item.isRead);

        this.setState({
            notificationsList: sorted,
            hasNotification: hasUnread,
        });

    } catch (err) {
        if (err.name === "AbortError") return;

        console.error("Error fetching notifications:", err);

        this.setState({
            notificationsList: [],
            hasNotification: false
        });

        sendLogError(err.message, "populateNotifications");
    }
  }
}

NotificationBanner.contextType = ContextConstructor;

export default NotificationBanner;
